
import { getStore } from '@/store';

export function genkey() {
    return Array.prototype.join.call(arguments, '-');
}

export function genTimeKey(lat, lng, idx) {
    return genkey(lat, lng, Date.now(), idx);
}

export const getBoundaryColor = function(mapTheme)  {
    let pageStore = getStore('page');
    return mapTheme === 'layout1' ? '#191919' : pageStore.getReallyRootVar('--color-theme');
}

export const getMapPathChangeData = function(mapCondition)  {
    let key = 'mapPath';
    if (
        mapCondition &&
        Object.keys(mapCondition).includes('mapRadius')
    ) {
        key = 'mapRadius';
        mapCondition = mapCondition.mapRadius;
    }
    return { [key]: mapCondition };
}

export const compareLargeSpace = function(el) {
    const parent = el.parentElement;
    const parentWidth = parent.clientWidth;

    const elRect = el.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    const leftSpace = elRect.left - parentRect.left;
    const rightSpace = parentWidth - leftSpace - el.offsetWidth;

    return leftSpace > rightSpace ? 'left' : 'right';
}